module.exports = __webpack_public_path__ + "img/dao-logo-old.afb061da.svg";